module.exports = __webpack_public_path__ + "static/img/number2.6363f510.png";